// src/app/redux/sagas/skillEvaluationSaga.js

import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import {
    fetchSkillEvalsByCampagneSuccess, fetchSkillEvalsByCampagneFail,
    fetchSkillEvalsByUserSuccess, fetchSkillEvalsByUserFail,
    createSkillEvalSuccess, createSkillEvalFail,
    updateSkillEvalSuccess, updateSkillEvalFail,
    deleteSkillEvalSuccess, deleteSkillEvalFail,
    setSkillEvalLoading,
    submitAutoEvalRequest,
    submitAutoEvalSuccess, submitAutoEvalFail,
    managerDecisionSuccess, managerDecisionFail,
    rfDecisionSuccess, rfDecisionFail,
    fetchManagerInboxSuccess, fetchManagerInboxFail,
    fetchRfInboxSuccess, fetchRfInboxFail,
} from "../actions/skillEvaluationActions";

import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from "../../../api";

const getUid   = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

export function* fetchSkillEvalsByCampagneSaga(action) {
    const { campagneId } = action.payload;
    const url   = `${API_BASE_URL}/api/skill-evaluations/campagne/${campagneId}`;
    const uid   = getUid();
    const token = getToken();

    yield put(setSkillEvalLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchSkillEvalsByCampagneSuccess(resp.data));
    } catch (e) {
        yield put(fetchSkillEvalsByCampagneFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setSkillEvalLoading(false));
    }
}

export function* fetchSkillEvalsByUserSaga(action) {
    const { userId } = action.payload;
    const url   = `${API_BASE_URL}/api/skill-evaluations/user/${userId}`;
    const uid   = getUid();
    const token = getToken();

    yield put(setSkillEvalLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchSkillEvalsByUserSuccess(resp.data));
    } catch (e) {
        yield put(fetchSkillEvalsByUserFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setSkillEvalLoading(false));
    }
}

export function* createSkillEvalSaga(action) {
    const { autoSubmit, ...dto } = action.payload;
    const url   = `${API_BASE_URL}/api/skill-evaluations`;
    const uid   = getUid();
    const token = getToken();

    yield put(setSkillEvalLoading(true));
    try {
        const resp = yield call(postRequest, { url, data: dto, uid, token });
        yield put(createSkillEvalSuccess(resp.data));
        
        if (autoSubmit) {
            yield put(submitAutoEvalRequest(resp.data.id));
        } else {
            yield call([Swal, Swal.fire], { icon: "success", text: "Évaluation créée", timer: 1500, showConfirmButton: false });
        }
    } catch (e) {
        yield put(createSkillEvalFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: e.response?.data?.message || "Erreur création évaluation", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setSkillEvalLoading(false));
    }
}

export function* updateSkillEvalSaga(action) {
    const { id, payload } = action.payload;
    const url   = `${API_BASE_URL}/api/skill-evaluations/${id}`;
    const uid   = getUid();
    const token = getToken();

    yield put(setSkillEvalLoading(true));
    try {
        const resp = yield call(putRequest, { url, data: payload, uid, token });
        yield put(updateSkillEvalSuccess(resp.data));
        yield call([Swal, Swal.fire], { icon: "success", text: "Évaluation modifiée", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(updateSkillEvalFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: e.response?.data?.message || "Erreur modification évaluation", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setSkillEvalLoading(false));
    }
}

export function* deleteSkillEvalSaga(action) {
    const { id } = action.payload;
    const url   = `${API_BASE_URL}/api/skill-evaluations/${id}`;
    const uid   = getUid();
    const token = getToken();

    yield put(setSkillEvalLoading(true));
    try {
        yield call(deleteRequest, { url, uid, token });
        yield put(deleteSkillEvalSuccess(id));
        yield call([Swal, Swal.fire], { icon: "success", text: "Évaluation supprimée", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(deleteSkillEvalFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: "Erreur suppression évaluation", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setSkillEvalLoading(false));
    }
}

export function* skillSubmitAutoEvalSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/skill-evaluations/${id}/submit-auto-eval`;
    const uid = getUid();
    const token = getToken();

    yield put(setSkillEvalLoading(true));
    try {
        const resp = yield call(postRequest, { url, data: {}, uid, token });
        yield put(submitAutoEvalSuccess(resp.data));
        yield call([Swal, Swal.fire], { icon: "success", text: "Auto-évaluation soumise", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(submitAutoEvalFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: "Erreur lors de la soumission", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setSkillEvalLoading(false));
    }
}

export function* skillManagerDecisionSaga(action) {
    const { id, payload } = action.payload;
    const url = `${API_BASE_URL}/api/skill-evaluations/${id}/manager-decision`;
    const uid = getUid();
    const token = getToken();

    yield put(setSkillEvalLoading(true));
    try {
        const resp = yield call(postRequest, { url, data: payload, uid, token });
        yield put(managerDecisionSuccess(resp.data));
        yield call([Swal, Swal.fire], { icon: "success", text: "Décision enregistrée", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(managerDecisionFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: "Erreur enregistrement décision", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setSkillEvalLoading(false));
    }
}

export function* skillRfDecisionSaga(action) {
    const { id, payload } = action.payload;
    const url = `${API_BASE_URL}/api/skill-evaluations/${id}/rf-decision`;
    const uid = getUid();
    const token = getToken();

    yield put(setSkillEvalLoading(true));
    try {
        const resp = yield call(postRequest, { url, data: payload, uid, token });
        yield put(rfDecisionSuccess(resp.data));
        yield call([Swal, Swal.fire], { icon: "success", text: "Décision enregistrée", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(rfDecisionFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: "Erreur enregistrement décision", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setSkillEvalLoading(false));
    }
}

export function* fetchSkillManagerInboxSaga() {
    const url = `${API_BASE_URL}/api/skill-evaluations/manager-inbox`;
    const uid = getUid();
    const token = getToken();

    yield put(setSkillEvalLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchManagerInboxSuccess(resp.data));
    } catch (e) {
        yield put(fetchManagerInboxFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setSkillEvalLoading(false));
    }
}

export function* fetchSkillRfInboxSaga() {
    const url = `${API_BASE_URL}/api/skill-evaluations/rf-inbox`;
    const uid = getUid();
    const token = getToken();

    yield put(setSkillEvalLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchRfInboxSuccess(resp.data));
    } catch (e) {
        yield put(fetchRfInboxFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setSkillEvalLoading(false));
    }
}